//获取日期
export function getNowFormatDate(seperator1 = '-') {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let strDate = date.getDate();
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
    }
    let currentdate = year + seperator1 + month + seperator1 + strDate;

    return currentdate;
};
//获取给定日期date的第几天days   返回值用seperator格式化 例如  返回今天起的后3天是哪一天   offSetDate(new date(), 3,seperator='-')
export function offSetDate(date, days, seperator = '-') {
    let oDate = new Date(date).valueOf();
    let nDate = oDate + (days * 24 * 3600 * 1000);
    nDate = new Date(nDate);
    let y = nDate.getFullYear().toString().padStart(2, 0);
    let m = (nDate.getMonth() + 1).toString().padStart(2, 0);
    let d = nDate.getDate().toString().padStart(2, 0);
    return `${y}${seperator}${m}${seperator}${d}`
}


//获取两日期之间日期列表函数
export function getdiffdate(stime, etime) {
    //初始化日期列表，数组
    var diffdate = [];
    var i = 0;
    //开始日期小于等于结束日期,并循环
    while (stime <= etime) {
        diffdate[i] = stime;
        //获取开始日期时间戳
        var stime_ts = new Date(stime).getTime();
        //增加一天时间戳后的日期
        var next_date = stime_ts + (24 * 60 * 60 * 1000);
        //拼接年月日，这里的月份会返回（0-11），所以要+1
        var next_dates_y = new Date(next_date).getFullYear() + '-';
        var next_dates_m = (new Date(next_date).getMonth() + 1 < 10) ? '0' + (new Date(next_date).getMonth() + 1) + '-' : (new Date(next_date).getMonth() + 1) + '-';
        var next_dates_d = (new Date(next_date).getDate() < 10) ? '0' + new Date(next_date).getDate() : new Date(next_date).getDate();

        stime = next_dates_y + next_dates_m + next_dates_d;
        //增加数组key
        i++;
    }

    return diffdate;
}

// 获取多少天后的时间 传天数
export function getTimeAfter(AddDayCount) {
    var dd = new Date();
    function checkT(s) {
        return s < 10 ? '0' + s : s;
    }
    dd.setDate(dd.getDate() + AddDayCount);//获取AddDayCount天后的日期 
    var y = dd.getFullYear();
    var m = dd.getMonth() + 1;//获取当前月份的日期 
    var d = dd.getDate();
    var h = dd.getHours();
    var mm = dd.getMinutes();
    var ss = dd.getSeconds();

    return y + "-" + checkT(m) + "-" + checkT(d) + " " + checkT(h) + ":" + checkT(mm) + ":" + checkT(ss);
}
/**
 * 获取从date时间开始的第几个月后的时间
 * mouthNum可为正数字  可负数字 可0
 */
export function getBeforeOrAfterMouthDate(date, mouthNum) {
    return addmulMonth(offSetDate(date, 0), mouthNum, '-');
}


/**date 日期字符串
 * monthNum月数
 * str date字符串以什么格式分割‘-’
 */
export function addmulMonth(dateStr, monthNum, str = '/') {
    var dateArr = dateStr.split(str);
    var year = dateArr[0]; //获取当前日期的年份
    var month = dateArr[1]; //获取当前日期的月份
    //var day = dateArr[2]; //获取当前日期的日
    //var days = new Date(year, month, 0);
    //days = days.getDate(); //获取当前日期中的月的天数
    var year2 = year;
    var month2 = parseInt(month) + parseInt(monthNum);
    if (month2 > 12) {
        year2 = parseInt(year2) + parseInt((parseInt(month2) / 12 === 0 ? 1 : parseInt(month2) / 12));
        month2 = parseInt(month2) % 12;
    }
    var days2 = new Date(year2, month2, 0);
    days2 = days2.getDate();
    /*计算当前几号*/

    if (month2 < 10) {
        month2 = '0' + month2 === 0 ? 1 : month2;
    }
    var t2 = year2 + str + month2 + str + days2;
    return t2;
}
/**
 *获取几个月前后的输入日期
 *{param:DateTime} date 输入日期(YYYY-MM-DD)
 *{param:number } monthNum 月数
 */
export function getPreMonthDay(date, monthNum) {
    var dateArr = date.split('-');
    var year = dateArr[0]; //获取当前日期的年份
    var month = dateArr[1]; //获取当前日期的月份
    var day = dateArr[2]; //获取当前日期的日
    // var days = new Date(year, month, 0);
    // days = days.getDate(); //获取当前日期中月的天数
    var year2 = year;
    var month2 = parseInt(month) + monthNum;
    if (month2 <= 0) {
        year2 = parseInt(year2) - parseInt(month2 / 12 === 0 ? 1 : parseInt(month2) / 12);
        month2 = 12 - (Math.abs(month2) % 12);
    }
    var day2 = day;
    var days2 = new Date(year2, month2, 0);
    days2 = days2.getDate();
    if (day2 > days2) {
        day2 = days2;
    }
    if (month2 < 10) {
        month2 = '0' + month2;
    }
    var t2 = year2 + '-' + month2 + '-' + day2;
    return t2;
}



/**************************************时间格式化处理************************************/
export function getDateByFormat(fmt, date) { //author: meizz   
    var o = {
        "M+": date.getMonth() + 1,                 //月份   
        "d+": date.getDate(),                    //日   
        "h+": date.getHours(),                   //小时   
        "m+": date.getMinutes(),                 //分   
        "s+": date.getSeconds(),                 //秒   
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度   
        "S": date.getMilliseconds()             //毫秒   
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}
export function getLastMonth(mouthNum) {
    var now = new Date();
    var year = now.getFullYear();//getYear()+1900=getFullYear()
    var month = now.getMonth() + 1;//0-11表示1-12月
    var day = now.getDate();
    var dateObj = {};
    if (parseInt(month) < 10) {
        month = "0" + month;
    }
    if (parseInt(day) < 10) {
        day = "0" + day;
    }

    dateObj.now = year + '-' + month + '-' + day;

    if (parseInt(month) === 1) {//如果是1月份，则取上一年的12月份
        dateObj.last = (parseInt(year) - 1) + '-12-' + day;
        return dateObj;
    }

    var preSize = new Date(year, parseInt(month) - 1, 0).getDate();//上月总天数
    if (preSize < parseInt(day)) {//上月总天数<本月日期，比如3月的30日，在2月中没有30
        dateObj.last = year + '-' + month + '-01';
        return dateObj;
    }

    if (parseInt(month) <= 10) {
        dateObj.last = year + '-0' + (parseInt(month) + mouthNum) + '-' + day;
        return dateObj;
    } else {
        dateObj.last = year + '-' + (parseInt(month) + mouthNum) + '-' + day;
        return dateObj;
    }

}

/**
 * 当月的时间 如：今天是8.8 则获取8.1-8.8时间
 */
export function getCurrentMonthTime() {
    var TimeNow = new Date();
    var startDay1 = new Date(TimeNow.getFullYear(), TimeNow.getMonth(), 1);//当月1号
    var endDay1 = new Date(TimeNow.getFullYear(), TimeNow.getMonth(), TimeNow.getDate(), TimeNow.getHours(), TimeNow.getMinutes(), TimeNow.getSeconds());//23:59:59 将结束时间改成前一天
    return [startDay1, endDay1];
}

/**
 *  formatDate(new Date(),"YY-MM-DD 00:00:00"); //2019-11-28 00:00:00
    formatDate(new Date().getTime(),'YY年MM月DD日');//2017年05月12日
    formatDate(new Date().getTime(),'今天是YY/MM/DD hh:mm:ss');//今天是2017/05/12 10:07:45
 */
export function formatDate(time, format = 'YY-MM-DD hh:mm:ss') {
    var date = new Date(time);
    var year = date.getFullYear(),
        month = date.getMonth() + 1,//月份是从0开始的
        day = date.getDate(),
        hour = date.getHours(),
        min = date.getMinutes(),
        sec = date.getSeconds();
    var preArr = Array.apply(null, Array(10)).map(function (elem, index) {
        return '0' + index;
    });////开个长度为10的数组 格式为 00 01 02 03

    var newTime = format.replace(/YY/g, year)
        .replace(/MM/g, preArr[month] || month)
        .replace(/DD/g, preArr[day] || day)
        .replace(/hh/g, preArr[hour] || hour)
        .replace(/mm/g, preArr[min] || min)
        .replace(/ss/g, preArr[sec] || sec);
    return newTime;
}

export function numberTypeconversionTime(value) {  //数字类型转为时:分:秒
    var theTime = parseInt(value);//秒
    var theTime1 = 0;//分
    var theTime2 = 0;//时
    if (theTime >= 60) {
        theTime1 = parseInt(theTime / 60);
        theTime = parseInt(theTime % 60);
        if (theTime1 >= 60) {
            theTime2 = parseInt(theTime1 / 60);
            theTime1 = parseInt(theTime1 % 60);
        }
    };
    var theTime_y = parseInt(theTime);
    if (theTime_y < 10) {
        theTime_y = '0' + theTime_y;
    }
    var results = "" + theTime_y;
    if (theTime1 > 0 || theTime1 === 0) {
        var theTime1_y = parseInt(theTime1);
        if (theTime1_y < 10) {
            theTime1_y = '0' + theTime1_y;
        }
        results = "" + theTime1_y + ":" + results;
    }
    if (theTime2 > 0 || theTime2 === 0) {
        var theTime2_y = parseInt(theTime2);
        if (theTime2_y < 10) {
            theTime2_y = '0' + theTime2_y;
        }
        results = "" + theTime2_y + ":" + results;
    }
    return results;
};
/**
 * 获取当月的最后一天
 * @param year 年份
 * @param month 月份
 **/
export function getLastDay(year, month) {
    var new_year = year;
    var new_month = month++;//取下一个月的第一天，方便计算（最后一天不固定）
    if (month > 12) {//如果当前大于12月，则年份转到下一年
        new_month -= 12;//月份减
        new_year++;//年份增
    }
    // 取当年当月对应的下个月的前一天，即当前月的最后一天
    var last_date = new Date(new_year, new_month, 0).getDate();
    return last_date;
}
/**
 * 获取当月的第一天   当天   最后一天
 */
export function getFirstNowLastDay() {
    var now = new Date();
    var strLink = "-";
    var year = now.getFullYear();
    var month = now.getMonth() + 1;
    var day = now.getDate();
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (day >= 1 && day <= 9) {
        day = "0" + day;
    }
    var firstDate = year + strLink + month + strLink + '01';
    var sysDate = year + strLink + month + strLink + day;
    var lastDay = getLastDay(year, month);
    var lastDate = year + strLink + month + strLink + lastDay;
    var returnArr = [firstDate, sysDate, lastDate];//以数组形式返回  
    return returnArr;
}


export function compareTime(t1, t2) {
    var date = new Date();
    var a = t1.split(":"); //['12','30','21']
    var b = t2.split(":"); //['11','12','15']
    return date.setHours(a[0], a[1]) > date.setHours(b[0], b[1]);
}

/* 对象转formData对象 */
export const getFormData = (object) => {
    const formData = new FormData();
    for (let key in object) {
        formData.append(key, object[key]);
    }
    return formData;
};

export const getUrlQuery = obj => {
    const objEntris = Object.entries(obj).map(item => item.join('='));
    return objEntris.join('&');
};

export const getUrlObj = str => {
    let obj = {};
    if (!str) {
        return obj;
    }
    const search = str?.split('?')?.[1]?.split('&');
    search.forEach(item => {
        const [key, value] = item.split('=');
        obj[key] = value;
    });
    return obj;
}

/**
 * 把北京时间转换为浏览器本地时区时间  仅传日期（默认 00:00:00）
 * @param {string} beijingTime - 北京时间，格式支持 YYYY-MM-DD HH:mm:ss / YYYY-MM-DD
 * @returns {string} 浏览器时区的本地时间（格式：YYYY-MM-DD HH:mm:ss），失败返回空字符串
 */
export const  beijingToBrowserTime = (beijingTime) => {
    // 1. 获取浏览器时区
    const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    try {
        // 2. 补全时间部分（如果只传日期，默认 00:00:00）
        const fullBeijingTime = beijingTime.includes(' ') ? beijingTime : `${beijingTime} 00:00:00`;
        
        // 3. 构造 UTC+8 的 ISO 格式字符串（关键：明确指定北京时间时区）
        const [datePart, timePart] = fullBeijingTime.split(' ');
        const isoString = `${datePart}T${timePart}+08:00`;
        
        // 4. 解析为 Date 对象并校验有效性
        const date = new Date(isoString);
        if (isNaN(date.getTime())) throw new Error('时间格式错误');
        
        // 5. 格式化为浏览器时区的本地时间
        const localTimeStr =  new Intl.DateTimeFormat('zh-CN', {
            timeZone: browserTimeZone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false // 24小时制
        }).format(date).replace(/\//g, '-'); // 统一替换为横杠格式

        return {
            browserTimeZone: browserTimeZone,
            beijingTime: beijingTime,
            localTime: localTimeStr,
            localDate: new Date(localTimeStr) // 原始时间对象，可进一步处理
        };
        
    } catch (err) {
        console.error('转换失败：', err.message);
        return '';
    }
}
/**
 * 将浏览器本地时区的时间转换为北京时间（UTC+8）
 * @param {string} localTimeStr - 浏览器本地时间字符串（格式：YYYY-MM-DD HH:mm:ss）
 * @returns {Object} 包含浏览器时区、原始本地时间、转换后北京时间的结果
 */
export const  convertLocalTimeToBeijingTime = (localTimeStr) => {
    try {
        // 1. 获取浏览器的时区标识（如 "America/New_York"）
        const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        console.log("浏览器时区：", browserTimeZone);

        // 2. 校验输入时间格式并补全（仅传日期时默认 00:00:00）
        const fullLocalTime = localTimeStr.includes(' ') ? localTimeStr : `${localTimeStr} 00:00:00`;
        const [datePart, timePart] = fullLocalTime.split(' ');
        
        // 3. 构造带浏览器时区的时间对象（关键：确保解析的是本地时区的时间）
        // 先创建一个基于浏览器时区的格式化器，反向解析时间
        const localDate = new Date(`${datePart}T${timePart}`);
        if (isNaN(localDate.getTime())) {
            throw new Error("无效的本地时间格式，请使用 YYYY-MM-DD HH:mm:ss 格式");
        }

        // 4. 将本地时间格式化为北京时间（UTC+8）
        const beijingTimeFormatted = new Intl.DateTimeFormat('zh-CN', {
            timeZone: 'Asia/Shanghai', // 固定为北京时间时区
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false // 24小时制
        }).format(localDate).replace(/\//g, '-'); // 统一替换为横杠格式

        // 5. 返回完整结果
        return {
            browserTimeZone: browserTimeZone,
            beijingTime: beijingTimeFormatted,
            localTime: localTimeStr,
            localDate: localDate // 原始时间对象，可进一步处理
        };
    } catch (error) {
        console.error("转换失败：", error.message);
        return null;
    }
}